<template>
  <el-dialog
    title="修改密码"
    :visible.sync="isShow"
    :show-close="false"
    width="400px"
  >
    <div>
      <el-form
        label-width="80px"
        :model="form"
        :rules="rules"
        ref="form"
        v-loading="isLoading"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            v-model="form.oldPassword"
            placeholder="请输入旧密码"
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            type="password"
            v-model="form.newPassword"
            placeholder="请输入新密码"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="newPassword2">
          <el-input
            type="password"
            v-model="form.newPassword2"
            placeholder="请再次输入新密码"
          />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="submit" type="primary">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios";
import config from "@/config/config";
import NodeRSA from "node-rsa";
export default {
  data() {
    return {
      isShow: false,
      isLoading: false,
      form: {
        oldPassword: "",
        newPassword: "",
        newPassword2: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: "请输入旧密码",
          },
        ],
        newPassword: [
          {
            required: true,
            validator: this.validatePassword,
          },
        ],
        newPassword2: [
          {
            required: true,
            validator: this.confirmPassword,
          },
        ],
      },
    };
  },
  methods: {
    show() {
      this.reset();
      this.isShow = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    reset() {
      this.form = {
        oldPassword: "",
        newPassword: "",
        newPassword2: "",
      };
    },
    cancel() {
      this.isShow = false;
    },
    submit() {
      this.$refs.form.validate((flag) => {
        if (!flag) {
          return;
        }

        let code = this.$store.state.userInfo.employeeCode;
        if (!code) {
          this.$message.warning("无法获取员工编号");
          return;
        }

        this.isLoading = true;
        let oldEncryptPassword = this.encrypt(this.form.oldPassword, "base64");
        let newEncryptPassword = this.encrypt(this.form.newPassword, "base64");
        axios
          .put("auth/employee/editPassword/" + code, {
            oldEncryptPassword,
            newEncryptPassword,
          })
          .then((resp) => {
            let data = resp.data;
            if (data.success) {
              this.$message.success("密码修改成功");
              this.isShow = false;
            } else {
              this.$message.warning(data.message);
            }
          })
          .catch(() => {
            this.$message.error("更新密码失败");
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    encrypt(val) {
      let pubKey = new NodeRSA(config.pubKey);
      return pubKey.encrypt(val, "base64");
    },
    confirmPassword(rule, val, callback) {
      this.validatePassword(rule, val, (err) => {
        if (err) {
          callback(err);
        } else {
          if (val !== this.form.newPassword) {
            callback(new Error("两次输入密码不一致"));
          }
        }

        callback();
      });
    },
    validatePassword(rule, val, callback) {
      if (!val) {
        callback(new Error("请输入新密码"));
        return;
      }

      if (val.length < 6) {
        callback(new Error("密码至少6位"));
        return;
      }

      callback();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/home/UpdatePasswordDialog.vue